import { Component, effect, Input, OnChanges, OnInit, signal, SimpleChanges } from "@angular/core";
import { IBeverage } from "app/models/beverage";
import { IKeg } from "app/models/keg";
import { IUnits } from "app/models/units";
import { UnitsHelper } from "app/services/units.helper";
import * as dateHelper from 'app/helpers/date.helpers';
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { CornyKegSvgComponent } from "app/pages/home/taps/cornykeg-svg/cornykeg-svg.component";
import { CornyKeg09SvgComponent } from "app/pages/home/taps/cornykeg09-svg/cornykeg09-svg.component";
import { CornyKeg12SvgComponent } from "app/pages/home/taps/cornykeg12-svg/cornykeg12-svg.component";
import { KegSvgComponent } from "app/pages/home/taps/keg-svg/keg-svg.component";
import { RouterModule } from "@angular/router";
import { Store } from "@ngrx/store";
import * as fromUnits from 'app/state/units';
import * as fromBeverage from 'app/state/beverage';

@Component({
  selector: "app-keg",
  templateUrl: "./keg.component.html",
  styleUrls: ["./keg.component.scss"],
  standalone: true,
  imports: [
    CommonModule,
    IonicModule,
    KegSvgComponent, CornyKegSvgComponent, CornyKeg09SvgComponent, CornyKeg12SvgComponent,
    RouterModule,
  ]
})
export class KegComponent implements OnChanges {


  unitTypes = this.store.selectSignal(fromUnits.getUnits);
  beverages = this.store.selectSignal(fromBeverage.selectAllEntities);
  @Input() keg: IKeg | undefined;
  @Input() searchPhrase!: string;

  dateHelper = dateHelper;
  today = new Date();

  display = signal(true);

  beverage: IBeverage | undefined = undefined;

  constructor(
    private store: Store,
    public unitsHelper: UnitsHelper
  ) {
    effect(() => {
      const beverageEntites = this.beverages();
      if (beverageEntites && this.keg) {
        this.beverage = beverageEntites[this.keg.beverageId ?? ''];
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.keg && this.beverage) {
      if (this.searchPhrase) {
        this.display.set(this.beverage.name.toLowerCase().includes(this.searchPhrase.toLowerCase()));
      } else {
        this.display.set(true);
      }
    }

  }
}
